import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import axios from 'axios'
// import useCountValue from './selectors'
import {GET_FULL_LIST} from './actionTypes'

import fetchData, {fetchContent} from '../../utils/fetch-data'
import config from '../../config'

const useFullListActions = () => {
  const dispatch = useDispatch()
  const getFullList = useCallback(() => {
    // const cityContent = await getFullListContent(baseUrlAlias)
    console.debug('get full list')
    dispatch({
      type: GET_FULL_LIST,
      // payload: fetchData(`/tickets/get-full-list/json/1`),
      payload: axios.get(config.getFullList),
    })
  }, [dispatch])
  return {getFullList}
}

export default useFullListActions
